import Checkbox from '@mui/material/Checkbox';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import { Controller, useFormContext } from 'react-hook-form';
import { PTypography } from '@/components/atoms/Typography/PTypography';

type RHFCheckboxProps = {
  name: string;
  label: string;
  sx?: FormControlLabelProps['sx'];
  isRequired?: boolean;
  isDisabled?: boolean;
  onValueChange?: (value: boolean) => void;
};

export default function RHFCheckbox({ name, label, sx, isRequired, isDisabled, onValueChange }: RHFCheckboxProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={false}
      render={({ field: { ref, onChange, ...field }, fieldState: { error } }) => (
        <>
          <FormControlLabel
            key={name}
            control={
              <Checkbox
                disabled={isDisabled}
                required={isRequired}
                checked={field.value}
                inputRef={ref}
                onChange={(e) => {
                  onChange(e.target.checked);
                  onValueChange?.(Boolean(e.target.checked));
                }}
                {...field}
              />
            }
            data-checkbox-label
            sx={sx}
            slotProps={{
              typography: {
                // @ts-expect-error
                'data-checkbox-label': true,
              },
            }}
            label={label}
          />
          {error ? (
            <PTypography variant="caption" color={'error'}>
              {error.message}
            </PTypography>
          ) : null}
        </>
      )}
    />
  );
}
